module.exports = ".info {\n  font-size: 15px;\n  color: gray;\n}"